import refetchToken from "./refetchToken";
import axiosInstance from "./axiosInstance";
import {clearStoredAuth, persistAuthTokens, readStoredAuthTokens} from "./authStorage";

const clearAuthAndRedirect = () => {
    clearStoredAuth();
    delete axiosInstance.defaults.headers.common['Authorization'];

    if (window.location.pathname !== '/login') {
        window.location.assign('/login');
    }
};

const rerunMutation = (mutationFn, variables) => {
    if (typeof mutationFn?.mutate === 'function') {
        mutationFn.mutate(variables);
        return;
    }

    if (typeof mutationFn === 'function') {
        mutationFn(variables);
    }
};

const handleUnauthorizedMutate401Error = async (error, refreshToken, mutationFn, variables, options = {}) => {
    if(error?.response?.status === 401){
        const storedRefreshToken = typeof refreshToken === 'string'
            ? refreshToken
            : readStoredAuthTokens().refreshToken;
        const onUnauthorized = options.onUnauthorized || clearAuthAndRedirect;

        if (!storedRefreshToken) {
            onUnauthorized();
            return true;
        }

        try {
            const res = await refetchToken(storedRefreshToken);
            const newAccessToken = res?.data?.access;

            if (!newAccessToken) {
                throw new Error('Token refresh did not return an access token.');
            }

            persistAuthTokens({
                accessToken: newAccessToken,
                refreshToken: storedRefreshToken,
            });
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`
            options.onTokenRefreshed?.(newAccessToken);
            rerunMutation(mutationFn, variables);
        } catch (refreshError) {
            onUnauthorized(refreshError);
        }

        return true;
    }

    return false;
};

export default handleUnauthorizedMutate401Error
